import { isCancelledError } from '@tanstack/react-query';
import { throwIfAborted } from '../abort.js';
/** One owner-scoped snapshot per visit; an explicit session refresh rechecks geography. */
export function fundingContextQuery(client) {
    return {
        queryKey: ['onramp', client.cacheKey, 'context'],
        queryFn: ({ signal }) => client.getContext(signal),
        staleTime: Infinity,
        gcTime: 60_000,
        // A connectivity hint is not evidence that this backend is unreachable.
        networkMode: 'always',
        retry: false,
        refetchOnWindowFocus: false,
        meta: { persist: false },
    };
}
export async function contextForSession(cache, client, signal, navigationKey = 0) {
    const previous = cache
        .getQueryCache()
        .findAll({ queryKey: ['onramp', client.cacheKey, 'session'] });
    const refresh = navigationKey !== 0 ||
        previous.some(({ state }) => Boolean(state.dataUpdatedAt || state.errorUpdatedAt));
    for (;;) {
        throwIfAborted(signal);
        try {
            const context = await cache.fetchQuery({
                ...fundingContextQuery(client),
                ...(refresh ? { staleTime: 0 } : {}),
            });
            throwIfAborted(signal);
            return context;
        }
        catch (error) {
            // A context observer can cancel its lookup during Strict Mode replay or
            // refresh without cancelling this session. Do not leak its CancelledError
            // into the session query: TanStack leaves that parent pending indefinitely.
            if (!isCancelledError(error))
                throw error;
        }
    }
}
